<template>
  <div id="address" class="slideUp" :class="{ padding: !isComponent() }">
    <BottomBar v-if="!isComponent()" />
    <i
      v-if="isComponent()"
      id="close"
      class="anyteachicon anyteach-guanbi"
      @click="selectAddress()"
    />
    <div v-if="!isLoading">
      <div class="top">
        <h1>
          <span v-if="data[0]">
            <span v-if="isComponent()">点按选择地址</span>
            <span v-else>
              <i class="anyteachicon anyteach-home" /> 我的地址
            </span>
          </span>
          <span v-else>您还没有地址</span>
        </h1>
      </div>
      <div class="middle">
        <h2 class="blue" @click="showSearch = true">+ 添加地址</h2>
        <h2 v-if="data[0]" @click="isEdit = !isEdit">
          <span v-if="!isEdit">编辑</span>
          <span v-else>完成</span>
        </h2>
      </div>

      <transition-group v-if="data[0]" tag="div" name="list" class="content">
        <div v-for="(item, index) in data" :key="item.a_id" class="item">
          <div :class="{ onEdit: isEdit }" class="text-container" @click="selectAddress(item)">
            <i class="anyteachicon anyteach-map-marker-alt" />
            <p>{{ item.address }}</p>
            <div v-if="selected" id="check">
              <i
                v-if="selected.a_id === item.a_id && !isEdit"
                class="anyteachicon anyteach-check-circle"
              />
            </div>
          </div>
          <div v-if="isEdit" class="delete" @click="deleteAddress(index, item)">
            <span>删除</span>
          </div>
        </div>
      </transition-group>
    </div>
    <div v-else class="empty">
      <inline-loading />
    </div>
    <enter v-if="showSearch" @close="showSearch = false" @location="addAddress(null, $event)" />
  </div>
</template>
<script>
import Enter from "./Enter"
import InlineLoading from "vux/src/components/inline-loading"
import BottomBar from "../public/footer"
export default {
  name: "Address",
  components: {
    Enter,
    InlineLoading,
    BottomBar,
  },
  props: ["selected"],
  data() {
    return {
      data: "",
      isEdit: false,
      showSearch: false,
      isLoading: true,
      selectedAddress: "",
    }
  },
  created() {
    this.getData()
  },
  activated() {
    document.getElementById("address").classList.add("slideUp")
  },
  methods: {
    selectAddress(item) {
      this.selectedAddress = item
      document.getElementById("address").classList.remove("slideUp")
      document.getElementById("address").classList.add("slideDown")
      setTimeout(() => {
        this.$emit("address", this.selectedAddress)
        document.getElementById("address").classList.remove("slideDown")
        this.isEdit = false
      }, 300)
    },
    isComponent() {
      return this.$route.path != "/address"
    },
    onSearchLocation(e) {
      this.showSearch = false
      let address
      if (e.id) {
        if (typeof e.address === "string") {
          address = `${e.name}—${e.district}${e.address}`
        } else {
          address = `${e.name}—${e.district}`
        }
        let lat = `${e.location.lat},${e.location.lng}`
        this.addAddress(lat, address)
      }
    },
    addAddress(lat, address) {
      this.showSearch = false
      this.$axios({
        url: window.PHP_ROOT + "/index/User/addradd/",
        data: {
          lat: " ",
          address: address,
          area: bus.user.area_id || 0,
        },
        method: "POST",
      }).then(({ data }) => {
        this.getData()
        if (data.code != 1) {
          this.$toast("添加地址失败")
        }
      }).catch(err => {
        this.$toast("添加地址失败，请稍后重试")
      })
    },
    deleteAddress(index, item) {
      this.isEdit = false
      if (item.a_id == this.selectedAddress.a_id) {
        this.selectedAddress = ""
      }
      this.data.splice(index, 1)
      this.$axios({
        url: window.PHP_ROOT + "/index/User/addrdelete/",
        data: { a_id: item.a_id },
        method: "POST",
      }).then(({ data }) => {
        this.getData()
        if (data.code != 1) {
          this.$toast("删除地址失败")
        }
      }).catch(err => {
        this.getData()
        this.$toastError("网络失败，请稍后重试")
      })
    },
    getData() {
      this.$axios(window.PHP_ROOT + "/index/User/addrselect/")
        .then(({ data }) => {
          this.data = data.sort((a, b) => b.a_id - a.a_id)
          this.isLoading = false
        }).catch(err => this.$toastError("网络失败，请稍后重试"))
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

.padding {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transition: all 0.5s !important;
  transform: translateY(30px);
}

.list-leave-active {
  position: absolute;
}

#close {
  margin-left: 5%;
  color: $grey;
  font-size: 17px;
}

.onEdit {
  margin-left: -50px !important;
  width: calc(100% + 50px) !important;
  padding-right: 50px !important;
}

#address {
  background: white;
  width: 100%;
  padding-top: 5%;
  .black-button {
    font-size: 15px;
    font-weight: bold;
    background: $black;
    border-radius: 3px;
    padding: 10px 17px;
    color: white;
    display: inline-block;
    margin-left: 5%;
  }

  .top {
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 30px auto 0 auto;
    // border-bottom: 1px solid #eee;
    padding: 0 0 15px 0;
    h1 {
      font-size: 25px;
      font-weight: bold;
      color: $black;
    }
    h2 {
      font-size: 15px;
      font-weight: 300;
      color: $black;
    }
  }

  .middle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 0 5% 15px 5%;
    border-bottom: 1px solid #eee;
    h2 {
      font-size: 15px;
      opacity: 0.6;
      font-weight: 500;
      transition: all 0.1s;
      &:active {
        transform: scale(0.9);
      }
    }

    .blue {
      color: $blue;
      opacity: 1;
    }
  }

  .content {
    margin-bottom: 20px;
    .selected {
      background: $red;
      * {
        color: white;
        border-color: $red !important;
      }
    }
    #check {
      color: #ff5d67;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
    .item {
      transition: transform 0.5s;
      width: 100%;
      color: $black;

      position: relative;
      &:active {
        background: #eee;
      }

      .text-container {
        transition: margin 0.5s;
        display: flex;
        align-items: center;
        /*padding-left: 5%;*/
        border-bottom: 1px solid #e9e9e9;
        width: 95%;
        margin-left: 5%;
        padding: 20px 0;
        padding-right: calc(5% + 13px);
      }
      i {
        font-size: 20px;
        margin-right: 7px;
        display: none;
      }
      p {
        font-weight: 400;
        @include avenir();
        font-size: 15px;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .delete {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 13px;
        height: 100%;
        width: 50px;
        display: flex;
        align-items: center;
        span {
          text-align: center;
          width: 100%;
          font-weight: bold;
          color: $red;
        }
      }
    }
  }
}
</style>
